import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: '/api/rezervacije/v1',
        // Keep the API's error body: without it every refusal reads as a generic error
        // and the code the screens branch on (slot taken, till refused…) never arrives.
        options: {
            updateDataOnError: true,
            beforeFetch({ options }) {
                options.headers = new Headers(options.headers)
                options.headers.set('Authorization', `Bearer ${appStore.getJWT()}`)

                return { options }
            },
            async onFetchError(ctx) {
                // A refused sign-in is not an expired session: the login screen says so itself.
                if (ctx.response?.status === 401 && appStore.isLoggedIn()) {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }

                return ctx
            },
        },
    })

    return { fetch }
})
